// These values must match exactly with your backend enum values
export const GENDER = [
  "MALE",
  "FEMALE",
  "NON_BINARY",
  "TRANSGENDER",
  "PREFER_NOT_TO_SAY",
  "OTHER",
];

export const ETHNICITIES = [
  "ASIAN",
  "BLACK",
  "AFRICAN_AMERICAN",
  "HISPANIC_OR_LATINO",
  "WHITE",
  "NATIVE_AMERICAN",
  "PACIFIC_ISLANDER",
  "MULTIRACIAL",
  "OTHER",
  "PREFER_NOT_TO_SAY",
];

export const LANGUAGES = [
  { id: 1, name: "Spanish" },
  { id: 2, name: "Hindi" },
  { id: 3, name: "English" },
  { id: 4, name: "Mandarin" },
  { id: 5, name: "Portuguese" },
  { id: 6, name: "Urdu" },
  { id: 7, name: "Nigerian Pidgin" },
  { id: 8, name: "Vietnamese" },
  { id: 9, name: "French" },
  { id: 10, name: "Russian" },
  { id: 11, name: "German" },
  { id: 12, name: "Arabic" },
  { id: 13, name: "Chinese" },
  { id: 14, name: "Indonesian" },
  { id: 15, name: "Japanese" },
  { id: 16, name: "Bengali" },
  { id: 17, name: "Marathi" },
  { id: 18, name: "Turkish" },
  { id: 19, name: "Others" },
];

// Optional: User-friendly display names
export const GENDER_DISPLAY = {
  MALE: "Male",
  FEMALE: "Female",
  NON_BINARY: "Non-Binary",
  TRANSGENDER: "Transgender",
  PREFER_NOT_TO_SAY: "Prefer Not to Say",
  OTHER: "Other",
};

export const ETHNICITY_DISPLAY = {
  ASIAN: "Asian",
  BLACK: "Black",
  AFRICAN_AMERICAN: "African American",
  HISPANIC_OR_LATINO: "Hispanic or Latino",
  WHITE: "White",
  NATIVE_AMERICAN: "Native American",
  PACIFIC_ISLANDER: "Pacific Islander",
  MULTIRACIAL: "Multiracial",
  OTHER: "Other",
  PREFER_NOT_TO_SAY: "Prefer Not to Say",
};
